import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';

import AdminMaterialList from '../../components/pages/admin/AdminMaterialList';
import AdminMaterialsList from '../../components/pages/admin/AdminMaterialsList';
import AccountBasicChange from '../../components/pages/common/AccountBasicChange';
import AccountBasicComplete from '../../components/pages/common/AccountBasicComplete';
import AccountInfo from '../../components/pages/common/AccountInfo';
import AccountWithdrawal from '../../components/pages/common/AccountWithdrawal';
import AccountWithdrawalComplete from '../../components/pages/common/AccountWithdrawalComplete';
import AuthLogin from '../../components/pages/common/AuthLogin';
import AuthPasswordReset from '../../components/pages/common/AuthPasswordReset';
import AuthPasswordResetComplete from '../../components/pages/common/AuthPasswordResetComplete';
import AuthPasswordResetInput from '../../components/pages/common/AuthPasswordResetInput';
import AuthPasswordResetSent from '../../components/pages/common/AuthPasswordResetSent';
import AuthRegister from '../../components/pages/common/AuthRegister';
import AuthRegisterComplete from '../../components/pages/common/AuthRegisterComplete';
import AuthRegisterInfo from '../../components/pages/common/AuthRegisterInfo';
import AuthRegisterSent from '../../components/pages/common/AuthRegisterSent';
import { ConfirmEmail } from '../../components/pages/common/ConfirmEmail';
import Contact from '../../components/pages/common/Contact';
import ContactComplete from '../../components/pages/common/ContactComplete';
import EmailChange from '../../components/pages/common/EmailChange';
import EmailChangeComplete from '../../components/pages/common/EmailChangeComplete';
import EmailChangeSent from '../../components/pages/common/EmailChangeSent';
// import EvaluationsList from '../../components/pages/common/EvaluationsList';
import FavoritesList from '../../components/pages/common/FavoritesList';
import MaterialsList from '../../components/pages/common/MaterialsList';
import NewsDetail from '../../components/pages/common/NewsDetail';
import NewsList from '../../components/pages/common/NewsList';
import ProductComplete from '../../components/pages/common/ProductComplete';
import ProductContact from '../../components/pages/common/ProductContact';
import ProductContactComplete from '../../components/pages/common/ProductContactComplete';
import ProductRegister from '../../components/pages/common/ProductRegister';
import ProductDeleteComplete from '../../components/pages/common/ProductDeleteComplete';
import ProductsList from '../../components/pages/common/ProductsList';
import MyListList from '../../components/pages/common/MyListList';
import MyListProduct from '../../components/pages/common/MyListProduct';
import CsvConfirmation from '../../components/pages/common/CsvConfirmation';
import Co2StandardList from '../../components/pages/common/Co2StandartdList';
import Co2Standard from '../../components/pages/common/Co2Standard';
import MakerApplyComplete from '../../components/pages/common/MakerApplyComplete';
import MaterialDetail from '../../components/pages/common/MaterialDetail';
import ProductEdit from '../../components/pages/common/ProductEdit';
import { AuthProvider } from '../../contexts/auth';
import AdminProductEdit from '../../components/pages/admin/AdminProductEdit';
import AdminEvaluation from '../../components/pages/admin/AdminEvaluation';
import AdminProductComplete from '../../components/pages/admin/AdminProductComplete';
import AdminProductRegister from '../../components/pages/admin/AdminProductRegister';
import Home from '../../components/pages/common/Home';
import AdminMaterialDetail from '../../components/pages/admin/AdminMaterialDetail';
import AdminMaterialComplete from '../../components/pages/admin/AdminMaterialComplete';
import AdminMaterialEdit from '../../components/pages/admin/AdminMaterialEdit';
import { SentryRoutes } from '../../config/sentry';
import { MaintenanceProvider } from '../../contexts/maintenance';
import NotFound from '../../components/uiParts/NotFound';
import Members from '../../components/pages/common/Members';
import MemberConfirmEmail from '../../components/pages/common/MemberConfirmEmail';
import MemberRegisterInfo from '../../components/pages/common/AuthMemberRegisterInfo';
import MemberRegisterComplete from '../../components/pages/common/AuthMemberRegisterComplete';
import { RouteTracker } from '../RouteTracker';

const RoutesIndex: React.FC = () => (
  <BrowserRouter>
    <MaintenanceProvider>
      <AuthProvider>
        <RouteTracker />
        <SentryRoutes>
          <Route path={`/account`} element={<AccountInfo />} />
          <Route path={`/account/basic`} element={<AccountBasicChange />} />
          <Route
            path={`/account/basic/complete`}
            element={<AccountBasicComplete />}
          />
          <Route path={`/account/email`} element={<EmailChange />} />
          <Route
            path={`/account/email/complete`}
            element={<EmailChangeComplete />}
          />
          <Route path={`/account/email/sent`} element={<EmailChangeSent />} />
          <Route path={`/account/withdraw`} element={<AccountWithdrawal />} />
          <Route path={`/product/new`} element={<ProductRegister />} />
          <Route path={`/product/edit/:id`} element={<ProductEdit />} />
          <Route
            path={`/account/withdraw/complete`}
            element={<AccountWithdrawalComplete />}
          />
          <Route path={`/auth/login`} element={<AuthLogin />} />
          <Route
            path={`/auth/password_reset`}
            element={<AuthPasswordReset />}
          />
          <Route
            path={`/auth/password_reset/complete`}
            element={<AuthPasswordResetComplete />}
          />
          <Route
            path={`/auth/password_reset/input`}
            element={<AuthPasswordResetInput />}
          />
          <Route
            path={`/auth/password_reset/sent`}
            element={<AuthPasswordResetSent />}
          />
          <Route path={`/auth/register`} element={<AuthRegister />} />
          <Route
            path={`/auth/register/complete`}
            element={<AuthRegisterComplete />}
          />
          <Route
            path={`/users/email_verification`}
            element={<ConfirmEmail />}
          />
          <Route path={`/auth/register/info`} element={<AuthRegisterInfo />} />
          <Route path={`/auth/register/sent`} element={<AuthRegisterSent />} />
          <Route path={`/contact`} element={<Contact />} />
          <Route path={`/contact/complete`} element={<ContactComplete />} />
          {/* <Route path={`/evaluation`} element={<EvaluationsList />} /> */}
          <Route
            path={`/exhibit_apply/complete`}
            element={<MakerApplyComplete />}
          />
          <Route path={`/favorite`} element={<FavoritesList />} />
          <Route path={`/material`} element={<MaterialsList />} />
          <Route path={`/material/graph`} element={<MaterialsList />} />
          <Route path={`/material/:id`} element={<MaterialDetail />} />
          <Route path={`/news/:type?`} element={<NewsList />} />
          <Route path={`/news/:type/:newsId`} element={<NewsDetail />} />
          <Route path={`/product`} element={<ProductsList />} />
          <Route path={`/product/complete`} element={<ProductComplete />} />
          <Route path={`/product/contact`} element={<ProductContact />} />
          <Route
            path={`/product/contact/complete`}
            element={<ProductContactComplete />}
          />
          <Route
            path={`/product/delete/complete`}
            element={<ProductDeleteComplete />}
          />
          <Route path={`/mylist`} element={<MyListList />} />
          <Route path={`/mylist/:id`} element={<MyListProduct />} />
          <Route
            path={`/standard/csv_confirmation`}
            element={<CsvConfirmation />}
          />
          <Route path={`/standard/list`} element={<Co2StandardList />} />
          <Route path={`/standard`} element={<Co2Standard />} />
          <Route path={`/members`} element={<Members />} />
          <Route
            path={`/members/email_verification`}
            element={<MemberConfirmEmail />}
          />

          <Route path={`/operator/material`} element={<AdminMaterialList />} />
          <Route
            path={`/operator/materials`}
            element={<AdminMaterialsList />}
          />
          <Route
            path={`/operator/materials/complete`}
            element={<AdminMaterialComplete />}
          />
          <Route
            path={`/operator/materials/new`}
            element={<AdminMaterialEdit />}
          />
          <Route
            path={`/operator/materials/edit/:id`}
            element={<AdminMaterialEdit />}
          />
          <Route path={`/standard/:id`} element={<Co2Standard />} />
          <Route
            path={`/operator/material/:id`}
            element={<AdminMaterialDetail />}
          />
          <Route
            path={`/operator/product/edit/:id`}
            element={<AdminProductEdit />}
          />
          <Route
            path={`/operator/evaluation/:id`}
            element={<AdminEvaluation />}
          />
          <Route
            path={`/operator/product/complete`}
            element={<AdminProductComplete />}
          />
          <Route
            path={`/operator/product/new`}
            element={<AdminProductRegister />}
          />
          <Route
            path={`/auth/member/register/info`}
            element={<MemberRegisterInfo />}
          />
          <Route
            path={`/auth/member/register/complete`}
            element={<MemberRegisterComplete />}
          />

          <Route path={`/home`} element={<Home />} />
          <Route path="*" element={<NotFound />} />
        </SentryRoutes>
      </AuthProvider>
    </MaintenanceProvider>
  </BrowserRouter>
);

export default RoutesIndex;
